module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "media-image-dialog",
    attrs: {
      "title": _vm.$t('title'),
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": function($event) {
        _vm.selected = null;
        _vm.fetchData()
      }
    },
    model: {
      value: (_vm.currentTag),
      callback: function($$v) {
        _vm.currentTag = $$v
      },
      expression: "currentTag"
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('el-tab-pane', {
      key: tag,
      staticClass: "image-content",
      attrs: {
        "label": _vm.$t(("tags." + tag)),
        "name": tag
      }
    }, [(!_vm.onUploading) ? _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.images[_vm.currentTag] || _vm.images[_vm.currentTag].length === 0),
        expression: "!images[currentTag] || images[currentTag].length === 0"
      }],
      staticClass: "no-image"
    }, [_vm._v(_vm._s(_vm.$t('empty')))]) : _vm._e(), _vm._v(" "), _c('el-radio-group', {
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    }, [(_vm.onUploading) ? _c('el-radio', {
      staticClass: "hide-input",
      attrs: {
        "label": -1,
        "disabled": true
      }
    }, [_c('div', {
      staticClass: "uploading-progress img cover"
    }, [_c('p', {
      staticClass: "hint"
    }, [_vm._v(_vm._s(_vm.$t('imageUploading')))]), _vm._v(" "), _c('el-progress', {
      staticClass: "uploader-progress-bar",
      attrs: {
        "percentage": _vm.progress * 0.8,
        "show-text": false
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.images[_vm.currentTag]), function(image, index) {
      return _c('el-radio', {
        key: image.id,
        staticClass: "hide-input",
        attrs: {
          "label": image.id
        }
      }, [_c('div', {
        staticClass: "img cover",
        class: {
          'selected': image.id === _vm.selected
        },
        style: ({
          'backgroundImage': 'url(' + image.file_url + ')'
        })
      }, [_c('i', {
        staticClass: "ppj-icon-ok"
      })]), _vm._v(" "), _vm._o(_c('el-tooltip', {
        attrs: {
          "effect": "light",
          "content": _vm.$t('hint.media.image.remove'),
          "placement": "top",
          "open-delay": 500,
          "popper-options": {
            removeOnDestroy: true
          }
        }
      }, [_c('a', {
        staticClass: "remove-btn",
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.remove(index)
          }
        }
      }, [_c('i', {
        staticClass: "ppj-icon-cancel danger"
      })])]), 0, image.id)], 1)
    })], 2)], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('ssuploader', {
    staticClass: "uploader-btn",
    attrs: {
      "url": _vm.uploadUrl,
      "data": _vm.uploadData,
      "name": "medium[file]",
      "extensions": _vm.extensions,
      "progress": _vm.progress,
      "uploading": _vm.onUploading,
      "accept": _vm.accept
    },
    on: {
      "update:progress": function($event) {
        _vm.progress = $event
      },
      "update:uploading": function($event) {
        _vm.onUploading = $event
      },
      "complete": _vm.uploadComplete
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.ok')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6120498c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/media/image.dialog.vue
// module id = 926
// module chunks = 3